import React, { useEffect, useState } from "react";
import Header from "../separate/Header.js";
import Footer from "../separate/Footer.js";
import { NavLink , Link} from "react-router-dom";
import{getCmsContent} from "../actions/axioss/cms.axios"
import { MdKeyboardArrowRight } from 'react-icons/md';

export default function HelpandCentre(){

const [helpandcentre,SetHelpandcentre]=useState([])
   useEffect(()=>
   {
    Helpandcentre();
   },[])
    const Helpandcentre =async()=>{
   
        var resp = await getCmsContent("helpandcentre");
        // console.log("cmslist",resp.data)
        if(resp?.status)
        SetHelpandcentre(resp.data);
    }
    return(
        <>
            <Header />
                <div className="privacy_policy">
                <div className="tf-container">
                <div className="row">
                    <section className="tf-page-title">
                        <div className="col-md-12">
                            <ul className="breadcrumbs" data-aos="fade-right">
                                <li><NavLink to="/">Home <MdKeyboardArrowRight/></NavLink></li>
                                <li>Help And Centre</li>
                            </ul>
                            <h4 className="page-title-heading" data-aos="fade-left">
                                Help And Centre
                            </h4>
                            
                            </div>
                        </section>
                    </div>
                    <div className="tf-add-nft" data-aos="fade-right">
                        <div className="content" data-aos="zoom-in">
                            <div dangerouslySetInnerHTML={{ __html: helpandcentre?.answer }}></div>
                        </div>
                    </div>
                </div>
                </div>
                
            <Footer />
        </>
    )
}